import { Box, Typography, Button } from "@mui/material"
import { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"
import YouTube from "react-youtube"

const Story = () => {
  const [showVideo, setShowVideo] = useState(false)
  const [showPlanH, setShowPlanH] = useState(false)
  const [showRoast, setShowRoast] = useState(false)
  const [showReckoning, setShowReckoning] = useState(false)
  const [showStones, setShowStones] = useState(false)
  const [showPact, setShowPact] = useState(false)
  const [showReplay, setShowReplay] = useState(false)

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  const cardStyle = {
    border: "2px solid #00e676",
    borderRadius: "24px",
    padding: "18px",
    backgroundColor: "rgba(44,83,100,0.92)",
    color: "#fff",
    boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
    cursor: "pointer",
    marginBottom: "18px",
    transition: "background 0.2s, box-shadow 0.2s",
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1a1a1a, #2c5364)",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: { xs: 2, sm: 8 },
        py: { xs: 4, md: 8 },
      }}
    >
      <Helmet>
        <title>The Story</title>
      </Helmet>
      <Typography
        variant="h2"
        sx={{
          fontWeight: 900,
          color: "#00e676",
          textAlign: "center",
          letterSpacing: 1,
          mb: 2,
          textShadow: "0 2px 12px rgba(0,0,0,0.45)",
        }}
      >
        The Story!
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          fontWeight: 500,
          color: "#fff",
          mb: 3,
          textShadow: "0 2px 8px rgba(0,0,0,0.25)",
          maxWidth: 900,
        }}
      >
        There's a lot going on here with this story and we've done our best to section things out accordingly. Below you'll find 3 options on how to follow along.
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: 400,
          color: "#fff",
          mb: 4,
          opacity: 0.85,
          maxWidth: 900,
        }}
      >
        Despite all surrounding municipalities amending their antiquated laws to allow liquor license holders to serve as an elected official, Highland Park has yet to do the same. In October 2023, the Ravinia Brewery had recently come under legal attack by the Ravinia Music Festival as they decided to file suit against the local Brewery, over the name Ravinia, in the neighborhood of Ravinia. Yes - you read that correctly. Conveniently, the co-owner of the brewery, Jeff Hoobler had recently won a seat on the City Council by landslide. This is something that the Mayor had never endorsed. In January 2024, after the Mayor signed off to renew the brewery's liquor license, "SOMEBODY" dug up an archaic law from the prohibition era that states any person who has a liquor license cannot serve as an elected official. This meant that Hoobler had to either give up his council seat or his brewery. A few short weeks later, the potential to amend the law, to save both Hoobler's seat and his brewery was put on the City Council's agenda. A large gathering of citizens showed up in support of Jeff Hoobler and the brewery in hopes that the council would amend the antiquated liquor law...
      </Typography>
      <Box
        sx={{
          width: { xs: "100%", sm: "80%", md: "60%" },
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Link to="/prologue" style={{ textDecoration: "none", width: "100%" }}>
          <Box sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              Prologue
            </Typography>
            <Typography>
              Starting from February 12th, 2024 with Kane's first public appearance in advocacy of allowing Jeff Hoobler to retain his council seat despite the fact that he had a liquor license. Although still new to the city, he knew that what was happening was unjust. After realizing that anybody had the chance to speak, he decided to stand up and say something.
            </Typography>
          </Box>
        </Link>
        <Link to="/bshakes" style={{ textDecoration: "none", width: "100%" }}>
          <Box sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              Masquerade of Folly
            </Typography>
            <Typography>
              After being told that his direct nature and utter lack of eloquence and refinement was turning people off, he decided to go back to the drawing board. Although frustrated with the split decisions of the council and ultimately being treated like and shooed away like a peasant, he decided to try something different.
            </Typography>
          </Box>
        </Link>
        <Link to="/plan" style={{ textDecoration: "none", width: "100%" }}>
          <Box sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              Revenue Plans
            </Typography>
            <Typography>
              After spending part of the spring and an entire summer trolling the wrong-doings of the Mayor and her allies, he had a chance to meet with the Mayor and the City Manager over coffee to discuss details on how we could all work together. Or so we all thought...
            </Typography>
          </Box>
        </Link>
        {!showVideo && (
          <Box onClick={() => setShowVideo(true)} sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              Closing Arguments
            </Typography>
            <Typography>
              We've effectively drug this thing out from February 12th until October 28th - One week before the national election. On the TOP-Middle section on the back of the ballot, voters have the opportunity to vote YES to allow all qualified citizens (including those with a liquor license) to serve as elected officials.
            </Typography>
          </Box>
        )}
        {showVideo && (
          <Box width="100%" mb={2}>
            <YouTube
              videoId="aqJ9HRxd6i0"
              opts={{
                width: "100%",
                playerVars: { autoplay: 1, cc_load_policy: 1 },
              }}
            />
          </Box>
        )}
        {/* The Long Game — bring the reader back in with a direct reveal */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 920,
            bgcolor: "linear-gradient(180deg, rgba(0,0,0,0.28), rgba(0,0,0,0.18))",
            border: "2px solid rgba(0,230,118,0.12)",
            borderRadius: 3,
            p: { xs: 2.5, md: 3.5 },
            mb: 4,
            boxShadow: "0 18px 40px rgba(0,0,0,0.6)",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            textAlign: "left",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box sx={{ position: "absolute", right: 16, top: 16, bgcolor: "rgba(0,230,118,0.06)", px: 2, py: 0.5, borderRadius: 2 }}>
            <Typography sx={{ color: "#00e676", fontWeight: 800, fontSize: 12 }}>THE LONG GAME</Typography>
          </Box>

          <Typography
            variant="h5"
            sx={{ color: "#00e676", fontWeight: 900, mb: 1.2 }}
          >
            Why I kept going
          </Typography>
          <Typography sx={{ color: "#fff", fontWeight: 700, mb: 1.1, maxWidth: 820 }}>
            This was never about the noise.
          </Typography>

          <Typography sx={{ color: "#dbeef0", opacity: 0.98, mb: 1.1, maxWidth: 820 }}>
            In May I found something that would tilt the whole stage — evidence sharp enough to wound a councilman’s reputation. But revelation without an audience is silence. So I created spectacle. I gave people a story to follow, faces to point at, and moments they could not forget.
          </Typography>

          <Typography sx={{ color: "#dbeef0", opacity: 0.96, mb: 0, maxWidth: 820 }}>
            I kept making scenes, not merely for the thrill — though there was that — but because the long game requires cover and momentum. They thought it was chaos. I called it choreography. Come April's election day they would remember everything.
          </Typography>
        </Box>
        
        {!showPlanH && (
          <Box onClick={() => setShowPlanH(true)} sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              Post November Election
            </Typography>
            <Typography>
              82% of the city voted YES to amend the antiquated liquor laws! However, instead of listening to the people and what they want, the Mayor and her cronies decided that they will go against the will of the people. Despite spending over $50,000 researching this topic and discussing it all year long, they decided that they will wait until after the local elections in the Spring of 2025 to revisit the matter.
            </Typography>
          </Box>
        )}
        {showPlanH && (
          <Box width="100%" mb={2}>
            <YouTube
              videoId="oIGX-ddlIfs"
              opts={{
                width: "100%",
                playerVars: { autoplay: 1, cc_load_policy: 1 },
              }}
            />
          </Box>
        )}
        {!showRoast && (
          <Box onClick={() => setShowRoast(true)} sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              The Roast
            </Typography>
            <Typography>
              Item number 4 - A resolution approving a third amendment to the City Manager Employment Agreement and approving a one-time bonus payment to the city manager. After years of catastrophic failures of city management, the Highland Park city council circus approves an increase in salary to the city manager, bringing her BASE PAY to a whopping $300,224. Plus bonus. Plus car allowance (because the city manager lives 30-45 minutes away in a different county).
            </Typography>
          </Box>
        )}
        {showRoast && (
          <Box width="100%" mb={2}>
            <YouTube
              videoId="gbnM9A0Bils"
              opts={{
                width: "100%",
                playerVars: { autoplay: 1, cc_load_policy: 1 },
              }}
            />
          </Box>
        )}
        {!showReckoning && (
          <Box onClick={() => setShowReckoning(true)} sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              The Reckoning
            </Typography>
            <Typography>
              <i>Join the Movement and Stay Informed!</i> The fight to make our town a better place is far from over, and I need your support to keep the momentum going. Stay up to date with the latest developments, updates, and opportunities to take action by subscribing to our mailing list here:{" "}
              <Link to="/subscribe" style={{ color: "#00e676", fontWeight: 700, textDecoration: "underline" }}>Subscribe</Link> Together, we can create meaningful change. Let’s keep pushing forward!
            </Typography>
          </Box>
        )}
        {showReckoning && (
          <Box width="100%" mb={2}>
            <YouTube
              videoId="BV8s3HU-l2E"
              opts={{
                width: "100%",
                playerVars: { autoplay: 1, cc_load_policy: 1 },
              }}
            />
          </Box>
        )}
        {!showStones && (
          <Box onClick={() => setShowStones(true)} sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              The Stones of Folly
            </Typography>
            <Typography>
              $850,000 for a 100-yard alley project—$200,000 wasted on "traffic control" at $426 per hour. And who benefited? Council Member Kimberly Stone, whose property value just increased a few hundred thousand. Mismanagement, waste, and a failure of leadership.
            </Typography>
          </Box>
        )}
        {showStones && (
          <Box width="100%" mb={2}>
            <YouTube
              videoId="NN-u8r_yF7k"
              opts={{
                width: "100%",
                playerVars: { autoplay: 1, cc_load_policy: 1 },
              }}
            />
          </Box>
        )}
                {/* Instant replay callout: Pavergate (Kim Stone) */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 920,
            bgcolor: "linear-gradient(90deg, rgba(0,230,118,0.03), rgba(0,0,0,0.06))",
            border: "2px solid rgba(0,230,118,0.10)",
            borderRadius: 3,
            p: { xs: 2, md: 3 },
            mb: 3,
            boxShadow: "0 14px 34px rgba(0,0,0,0.45)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" sx={{ color: "#00e676", fontWeight: 900, mb: 1 }}>
            Let's see that in an instant replay
          </Typography>

          <Typography sx={{ color: "#fff", mb: 1.2, maxWidth: 820 }}>
            Kim Stone's political fortunes unraveled after The Stones of Folly — the permeable brick paver debacle that social media quickly dubbed "Pavergate." The uproar was loud, and the fallout cost her the election.
          </Typography>

          <Typography sx={{ color: "#dbeef0", opacity: 0.95, mb: 1.5, maxWidth: 820 }}>
            Watch the moment that ignited the controversy and decide for yourself why it became a turning point.
          </Typography>

          {!showReplay ? (
            <Button
              onClick={() => setShowReplay(true)}
              sx={{
                backgroundColor: "#00e676",
                color: "#000",
                fontWeight: 800,
                borderRadius: "28px",
                px: 4,
                py: 1.25,
                boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
                '&:hover': { backgroundColor: '#00c853' },
              }}
              variant="contained"
            >
              Play Instant Replay
            </Button>
          ) : (
            <Box width="100%" mb={2} sx={{ mt: 1 }}>
              <YouTube
                videoId="00gTSwVFKgI"
                opts={{ width: "100%", playerVars: { autoplay: 1, cc_load_policy: 1 } }}
              />
            </Box>
          )}
        </Box>
        {!showPact && (
          <Box onClick={() => setShowPact(true)} sx={cardStyle}>
            <Typography fontWeight={700} fontSize={22} color="#00e676" mb={1}>
              The Ravinia Pact
            </Typography>
            <Typography>
              A $2.5 million reinvestment into Highland Park—funded by the Ravinia Festival, not the taxpayers. Ten years of support for small businesses, protection from future lawsuits, and renewed trust between neighbors. Real leadership. Real results. Who will consider it?
            </Typography>
          </Box>
        )}
        {showPact && (
          <Box width="100%" mb={2}>
            <YouTube
              videoId="fVO2fPklFDs"
              opts={{
                width: "100%",
                playerVars: { autoplay: 1, cc_load_policy: 1 },
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Story
